// Core
import { createAsyncThunk } from '@reduxjs/toolkit';

// Boosters
import { AxiosError } from 'axios';

export const updateRocketValue = createAsyncThunk<
    number,
    number
>(
  'aviator/update-rocket-value',
  async (value, { rejectWithValue }) => {
    try {
      return value;
    } catch (error) {
      const err = error as AxiosError;
      return rejectWithValue(err);
    }
  },
);
